import { data } from 'react-router'
import Footer from '#app/components/footer.tsx'
import { HeroCarousel } from '#app/components/hero-carousel.tsx'
import FunctionalReachSection from '#app/components/technology/functional-reach-section.tsx'
import IndustryDigitalizationSection from '#app/components/technology/industry-digitalization-section.tsx'
import InnovationCommitment from '#app/components/technology/innovation-commitment-section.tsx'
import {
	ContactoAliadosSchema,
	sendContactoAliadosEmail,
} from '#app/utils/email.server.ts'
import { type Route } from './+types/index.ts'
import { slidesTechnology } from './config.ts'

export const meta: Route.MetaFunction = () => [
	{ title: '100prevalor - Avanza hacia un futuro seguro' },
	{
		name: 'description',
		content: 'Sostenibilidad y valor para un futuro mejor',
	},
]

export async function action({ request }: Route.ActionArgs) {
	const formData = await request.formData()

	const formDataObject = Object.fromEntries(formData)

	// Validar datos con Zod schema
	const validation = ContactoAliadosSchema.safeParse(formDataObject)

	if (!validation.success) {
		const errors: Record<string, string[]> = {}

		validation.error.errors.forEach((error) => {
			const field = error.path[0] as string
			if (!errors[field]) {
				errors[field] = []
			}
			errors[field].push(error.message)
		})

		return data({ success: false, errors })
	}

	try {
		// Enviar email usando el servicio
		await sendContactoAliadosEmail(validation.data)

		return data({
			success: true,
			message:
				'¡Gracias por tu interés! Hemos recibido tu información y te contactaremos pronto para explorar oportunidades de colaboración.',
		})
	} catch (error) {
		console.error('Error enviando formulario de aliados:', error)
		return data({
			success: false,
			message:
				'Ocurrió un error al enviar el formulario. Por favor intenta nuevamente o contactanos directamente.',
		})
	}
}

export default function Index() {
	return (
		<main className="font-parkinsans">
			{/* Hero Section */}
			<HeroCarousel
				showActionButton={false}
				showIndicators={false}
				showControls={false}
				slides={slidesTechnology}
			/>
			{/* Industry Digitalization Section */}
			<IndustryDigitalizationSection />
			{/* Functional Reach Section */ <FunctionalReachSection />}
			{/* Innovation Commitment */}
			<InnovationCommitment />
			{/* Footer */}
			<Footer />
		</main>
	)
}
